module.exports = __webpack_public_path__ + "img/9788988996782.3906be1c.jpg";